import axios from "axios"
import Cookies from "js-cookie"
import { FIRMFLOWURL } from "./url";
const EMPLOYEES_REQUEST_TIMEOUT = 15000;
let inFlightEmployeesRequest = null;

export const getEmployees = (form) => {
    if (inFlightEmployeesRequest) return inFlightEmployeesRequest;

    inFlightEmployeesRequest = (async () => {
        try {
            const token = Cookies.get('Bearer');
            const response = await axios.get(`${FIRMFLOWURL}api/Employee/firm/all`,
                {
                    headers: { 'Authorization': token },
                    timeout: EMPLOYEES_REQUEST_TIMEOUT,
                }
            )
            return { ...response, success: true };
        } catch (err) {
            const status = err.response?.status;
            if (status === 401) {
                Cookies.remove('Bearer');
                window.location.replace('/');
            }
            return {
                success: false,
                status,
                message: err.response?.data?.message || err.message || "Request failed.",
            };
        }
    })().finally(() => {
        inFlightEmployeesRequest = null;
    });

    return inFlightEmployeesRequest;
}